

import React, { useState } from "react";
import { Link } from "react-router-dom";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase/firebase";
import { Helmet } from "react-helmet-async";

export default function Contact() {
  const [loading, setLoading] = useState(false);

  const handleFirestoreSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const name = e.target.name.value;
    const email = e.target.email.value;
    const message = e.target.message.value;

    try {
      await addDoc(collection(db, "messages"), {
        name,
        email,
        message,
        createdAt: serverTimestamp(),
      });

      alert("Your message was successfully sent! Thank you.");
      e.target.reset();
    } catch (error) {
      alert("Error sending message. Please try again.");
      console.error(error);
    }

    setLoading(false);
  };

  return (
    <>
      {/* SEO */}
      <Helmet>
        <title>Contact Maniera | Salon Software & Booking System Experts</title>

        <meta
          name="description"
          content="Contact ManieraDigital for custom salon software, booking systems, and client dashboard solutions. Get expert consultation for your salon business."
        />

        <link rel="canonical" href="https://www.manieradigital.com/contact" />

        <meta property="og:title" content="Contact Maniera Digital" />
        <meta
          property="og:description"
          content="Get in touch for custom salon software, booking systems and digital solutions."
        />
        <meta property="og:type" content="website" />
      </Helmet>

      {/* HERO */}
      <section className="contact-hero d-flex align-items-center justify-content-center">
        <div className="text-center contact-hero-content">
          <h1>Contact Maniera Digital</h1>
          <p>
            Get in touch to build your custom salon software, booking system, 
            and client dashboard solution.
          </p>
        </div>
      </section>

      {/* MAIN CONTAINER */}
      <div className="container py-5">

        {/* Title Block */}
        <div className="text-center mb-5">
          <h2 className="contact-title">Start Your Salon Project</h2>
          <p className="contact-subtitle">
            Choose the best way to discuss your booking system, dashboard, or digital solution.
          </p>
        </div>

        {/* ===== CONSULTATION ===== */}
        <div className="row align-items-center mb-5">
          <div className="col-lg-6 mb-4 mb-lg-0">
            <div className="contact-img consult-img"></div>
          </div>

          <div className="col-lg-6">
            <h3 className="contact-block-title">
              Salon Software Consultation & Strategy
            </h3>
            <p className="contact-block-text">
              Get expert guidance on building your custom salon software, booking system, 
              and client dashboard. We help you design a platform that improves workflow, 
              automation, and online visibility.
            </p>

            <a
              href="mailto:info@manieradigital.com?subject=Consultation Request"
              className="hero-button contact-btn"
            >
              Request Consultation
            </a>
          </div>
        </div>

        {/* ===== WRITE US ===== */}
        <div className="row align-items-center mb-5 flex-lg-row-reverse">
          <div className="col-lg-6 mb-4 mb-lg-0">
            <div className="contact-img write-img"></div>
          </div>

          <div className="col-lg-6">
            <h3 className="contact-block-title">
              Send Your Salon Project Details
            </h3>
            <p className="contact-block-text">
              Tell us about your salon, booking needs, or software idea. 
              We’ll respond with a tailored solution focused on automation, 
              scheduling, and business growth.
            </p>

            <form className="contact-form" onSubmit={handleFirestoreSubmit}>
              <input
                type="text"
                name="name"
                className="contact-input"
                placeholder="Your Name"
                required
              />

              <input
                type="email"
                name="email"
                className="contact-input"
                placeholder="Email Address"
                required
              />

              <textarea
                name="message"
                rows="4"
                className="contact-input"
                placeholder="Your Message"
                required
              />

              <button
                type="submit"
                className="hero-button contact-btn"
                disabled={loading}
              >
                {loading ? "Sending..." : "Send Message"}
              </button>
            </form>
          </div>
        </div>

        {/* ===== CALL US ===== */}
        <div className="row align-items-center mb-5">
          <div className="col-lg-6 mb-4 mb-lg-0">
            <div className="contact-img phone-img"></div>
          </div>

          <div className="col-lg-6">
            <h3 className="contact-block-title">
              Direct Contact for Salon Software Support
            </h3>
            <p className="contact-block-text">
              Speak directly with us about your salon system, booking platform, 
              or technical support. Fast response for serious business inquiries.
            </p>
            <a href="tel:+38669663573" className="hero-button contact-btn">
              Call Now
            </a>
          </div>
        </div>

        {/* Back Home */}
        <div className="text-center mt-5">
          <Link to="/" className="hero-button back-home">
            Back to Home
          </Link>
        </div>
      </div>
    </>
  );
}